import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { BUTTON_BASE_RESET_CSS } from '@pkg/components/Sections/Profile/Buttons';

export const StyledLink = styled(Link)`
    &&&& {
        ${BUTTON_BASE_RESET_CSS}
        max-width: 100%;
        display: block;
        text-align: left;
    }
`;
